import React, { Component } from 'react';
import './btn.scss';
import { GECKO_CONSTS, GECKO_UTILS } from '../../';
import { GeckoIcon } from '../';
import { OverlayTrigger, Tooltip } from 'ui'
import { GeckoBtnModel } from '../../models';

class GeckoBtn extends Component {
  state = {
    disabled: false,
    iconPosition: this.props.iconPosition ? this.props.iconPosition : 'left',
  };

  renderId() {
    if (!this.btnId) this.btnId = GECKO_UTILS.generateUniqueId();
    return `gecko-btn-${this.btnId}`;
  }

  preparePreset(key) {
    if (
      this.props.preset &&
      GECKO_CONSTS.BTN_PRESETS[this.props.preset] &&
      GECKO_CONSTS.BTN_PRESETS[this.props.preset][key]
    ) {
      return GECKO_CONSTS.BTN_PRESETS[this.props.preset][key];
    }
    return null;
  }

  // Prepare class name
  prepareClass() {
    let type =
      this.props.type ||
      this.preparePreset('type') ||
      GECKO_CONSTS.BTN_TYPE_DEFAULT;
    return GECKO_CONSTS.BTN_CLASSES[type];
  }

  prepareIcon(icon) {
    return icon || this.preparePreset('icon');
  }

  // Render button name
  renderName() {
    return this.props.name || this.preparePreset('name') || null;
  }

  // Render button class
  renderClass() {
    return GECKO_UTILS.classNames({
      [GECKO_UTILS.prepareNameClass('gecko-btn', this.renderName())]:
        this.renderName(),
      'gecko-btn gecko-ui-material btn': true,
      [this.prepareClass()]: true,
      'icon-only':
        !this.renderName() && (this.renderLeftIcon() || this.renderRightIcon()),
      [`btn-${this.props.size}`]: this.props.size,
      [this.props.className]: this.props.className,
    });
  }

  renderIcon(icon, position) {
    if (icon || this.preparePreset('icon')) {
      return <GeckoIcon icon={`${this.prepareIcon(icon)} icon-${position}`} />;
    }
    return null;
  }

  renderLeftIcon() {
    if (this.props.icon || this.preparePreset('icon')) {
      return this.renderIcon(this.props.icon, 'left');
    }
    return null;
  }

  renderRightIcon() {
    if (this.props.iconRight) {
      return this.renderIcon(this.props.iconRight, 'right');
    }
    return null;
  }

  renderTooltip(props) {
    if (this.props.tooltip) {
      //Determine what tooltp to show (defaults to button name)
      if (typeof this.props.tooltip === 'string') {
        this.tooltip = { name: this.props.tooltip };
      } else if (typeof this.props.tooltip === 'object') {
        this.tooltip = { ...this.props.tooltip };
      } else if (this.props.name) {
        this.tooltip = { name: this.props.name };
      }

      return (
        <Tooltip id={this.renderId()} {...props}>
            {this.tooltip.name}
        </Tooltip>
      );
    }
    return null;
  }

  isDisabled() {
    return (
      this.state.disabled ||
      (this.props.disabledWhen ? this.props.disabledWhen() : false)
    );
  }

  isHidden() {
    return this.props.hideWhen ? this.props.hideWhen() : false;
  }

  handler(event) {
    let handler = this.props.handler(event);

    // If promise is returned disable button
    if (handler && typeof handler === 'object' && handler.then) {
      // Disable button
      this.setState({ disabled: true });
      // Undisable button after promise has resolved or rejected
      return handler
        .then(() => {
          return this.setState({ disabled: false });
        })
        .catch(() => {
          return this.setState({ disabled: false });
        });
    }
  }

  render() {
    if (this.props.tooltip) {
      return (
        <OverlayTrigger
          placement={this.props.tooltip.placement || 'top center'}
          overlay={this.renderTooltip()}
        >
          <button
            type="button"
            id={this.renderId()}
            className={this.renderClass()}
            onClick={(event) => this.handler(event)}
            disabled={this.isDisabled()}
            hideWhen={this.isHidden()}
          >
            {this.renderLeftIcon()}

            {this.renderName()}

            {this.renderRightIcon()}
          </button>
        </OverlayTrigger>
      );
    }
    return (
      <button
        type="button"
        id={this.renderId()}
        className={this.renderClass()}
        onClick={(event) => this.handler(event)}
        disabled={this.isDisabled()}
        hideWhen={this.isHidden()}
      >
        {this.renderLeftIcon()}

        {this.renderName()}

        {this.renderRightIcon()}
      </button>
    );
  }
}

GeckoBtn.defaultProps = {
  handler: () => {},
};

GeckoBtn.propTypes = GeckoBtnModel;

export default GeckoBtn;
